"use strict";
// Copyright 2019-2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
var DefaultAudioVideoController_1 = require("../audiovideocontroller/DefaultAudioVideoController");
var DefaultAudioVideoFacade_1 = require("../audiovideofacade/DefaultAudioVideoFacade");
var FullJitterBackoff_1 = require("../backoff/FullJitterBackoff");
var DefaultBrowserBehavior_1 = require("../browserbehavior/DefaultBrowserBehavior");
var ContentShareMediaStreamBroker_1 = require("../contentsharecontroller/ContentShareMediaStreamBroker");
var DefaultContentShareController_1 = require("../contentsharecontroller/DefaultContentShareController");
var DefaultReconnectController_1 = require("../reconnectcontroller/DefaultReconnectController");
var DefaultScreenShareFacade_1 = require("../screensharefacade/DefaultScreenShareFacade");
var DefaultScreenShareViewFacade_1 = require("../screenshareviewfacade/DefaultScreenShareViewFacade");
var DefaultWebSocketAdapter_1 = require("../websocketadapter/DefaultWebSocketAdapter");
var DefaultMeetingSession = /** @class */ (function () {
    function DefaultMeetingSession(configuration, logger, deviceController) {
        this._configuration = configuration;
        this._logger = logger;
        this._deviceController = deviceController;
        this._deviceController.enableWebAudio(configuration.enableWebAudio);
        this.audioVideoController = new DefaultAudioVideoController_1.default(this._configuration, this._logger, new DefaultWebSocketAdapter_1.default(this._logger), deviceController, new DefaultReconnectController_1.default(DefaultMeetingSession.RECONNECT_TIMEOUT_MS, new FullJitterBackoff_1.default(DefaultMeetingSession.RECONNECT_FIXED_WAIT_MS, DefaultMeetingSession.RECONNECT_SHORT_BACKOFF_MS, DefaultMeetingSession.RECONNECT_LONG_BACKOFF_MS)));
        deviceController.bindToAudioVideoController(this.audioVideoController);
        this.screenShareFacade = new DefaultScreenShareFacade_1.default(this._configuration, this._logger, deviceController);
        this.screenShareViewFacade = new DefaultScreenShareViewFacade_1.default(this._configuration, this._logger);
        var contentShareMediaStreamBroker = new ContentShareMediaStreamBroker_1.default(this._logger);
        this.contentShareController = new DefaultContentShareController_1.default(contentShareMediaStreamBroker, new DefaultAudioVideoController_1.default(DefaultContentShareController_1.default.createContentShareMeetingSessionConfigure(this._configuration), this._logger, new DefaultWebSocketAdapter_1.default(this._logger), contentShareMediaStreamBroker, new DefaultReconnectController_1.default(DefaultMeetingSession.RECONNECT_TIMEOUT_MS, new FullJitterBackoff_1.default(DefaultMeetingSession.RECONNECT_FIXED_WAIT_MS, DefaultMeetingSession.RECONNECT_SHORT_BACKOFF_MS, DefaultMeetingSession.RECONNECT_LONG_BACKOFF_MS))));
        this.audioVideoFacade = new DefaultAudioVideoFacade_1.default(this.audioVideoController, this.audioVideoController.videoTileController, this.audioVideoController.realtimeController, this.audioVideoController.audioMixController, this._deviceController, this.contentShareController);
        this.checkBrowserSupport();
    }
    Object.defineProperty(DefaultMeetingSession.prototype, "configuration", {
        get: function () {
            return this._configuration;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultMeetingSession.prototype, "logger", {
        get: function () {
            return this._logger;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultMeetingSession.prototype, "audioVideo", {
        get: function () {
            return this.audioVideoFacade;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultMeetingSession.prototype, "contentShare", {
        get: function () {
            return this.contentShareController;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultMeetingSession.prototype, "screenShare", {
        get: function () {
            return this.screenShareFacade;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultMeetingSession.prototype, "screenShareView", {
        get: function () {
            return this.screenShareViewFacade;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultMeetingSession.prototype, "deviceController", {
        get: function () {
            return this._deviceController;
        },
        enumerable: true,
        configurable: true
    });
    DefaultMeetingSession.prototype.checkBrowserSupport = function () {
        var browserBehavior = new DefaultBrowserBehavior_1.default();
        var browser = browserBehavior.name() + " " + browserBehavior.majorVersion() + " (" + browserBehavior.version() + ")";
        this.logger.info("browser is " + browser);
        if (!browserBehavior.isSupported()) {
            this.logger.warn('this browser is not currently supported. ' +
                'Stability may suffer. ' +
                ("Supported browsers are: " + browserBehavior.supportString() + "."));
        }
    };
    DefaultMeetingSession.RECONNECT_TIMEOUT_MS = 120 * 1000;
    DefaultMeetingSession.RECONNECT_FIXED_WAIT_MS = 0;
    DefaultMeetingSession.RECONNECT_SHORT_BACKOFF_MS = 1 * 1000;
    DefaultMeetingSession.RECONNECT_LONG_BACKOFF_MS = 5 * 1000;
    return DefaultMeetingSession;
}());
exports.default = DefaultMeetingSession;
//# sourceMappingURL=DefaultMeetingSession.js.map